export const DRUG_REFERENCE_COLLECTIONS = Object.freeze({
  DRUGS: 'drugs',
  DRUG_METADATA: 'drugMetadata',
  REFRESH_SCHEDULES: 'refreshSchedules',
  DRUG_UPDATE_QUEUE: 'drugUpdateQueue',
  DRUG_UPDATE_LOG: 'drugUpdateLog',
});

export const DRUG_METADATA_DOCS = Object.freeze({
  SPECIALTIES: 'specialties',
  CURATED_LISTS: 'curatedLists',
});

export const EMERGENCY_MEDICINE_SPECIALTY = 'emergency-medicine';

export const REVIEW_STATUS = Object.freeze({
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
});

export const QUEUE_STATUS = Object.freeze({
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
});

export const EM_RELEVANCE = Object.freeze({
  ADULT: 'adult',
  PEDS: 'peds',
  BOTH: 'both',
});

export const SUPPORTED_COUNTRIES = Object.freeze(['US', 'UK', 'EU', 'AU']);
